import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FixedSizeGrid } from 'react-window';
import {
  Table,
  Box,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  Divider,
  makeStyles
} from '@material-ui/core';
import './style.css';
import moment from 'moment';
import VehicleTablecell from './VehicleTablecell';
import { useNavigate } from 'react-router';
import { reportSubmenu, roadSubmenu } from './constance';
import { setTimeSearching } from 'src/features/deviceSlice';

// Man Giam sat
const VehicleTable = ({ vehicles, getVehicle, idSelected }) => {
  const [rowActive, setRowActive] = useState(null);
  const [allVehicles, setAllVehicles] = useState([]);
  const [menuPosition, setMenuPosition] = useState(null);
  const [menuRowIndex, setMenuRowIndex] = useState(null);

  const [submenuPosition, setSubmenuPosition] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [menuType, setMenuType] = useState([]);
  const [vehicleSub, setVehicleSub] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const isCamera4G =
    vehicleSub && vehicleSub.device_type === 'VGPS_CAM4G' ? true : false;
  const isCar4G =
    (vehicleSub && vehicleSub.device_type === 'VGPS_CAM4G') ||
    (vehicleSub && vehicleSub.device_type === 'VGPS_CAR4G')
      ? true
      : false;

  useEffect(() => {
    const sortedVehicles = [...vehicles].sort((a, b) => {
      if (a.debt && !b.debt) return 1;
      if (!a.debt && b.debt) return -1;
      return b.device_id - a.device_id;
    });
    setAllVehicles(sortedVehicles);
  }, [vehicles]);

  useEffect(() => {
    if (idSelected) {
      setRowActive(idSelected);
    }
  }, [idSelected]);

  useEffect(() => {
    if (idSelected !== undefined) {
      setRowActive(idSelected);
    } else if (idSelected === undefined && rowActive) {
      setRowActive(null);
    }
  }, [idSelected, rowActive]);

  const handleRowClick = vehicle => {
    setMenuPosition(null);
    setRowActive(vehicle.device_id);
    getVehicle(vehicle);
  };

  const handleClickMenu = (event, rowIndex, vehicle) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.bottom - 134; 
    let left = rect.left + 38;

    setMenuPosition({ top, left });
    setMenuRowIndex(rowIndex);
    setVehicleSub(vehicle);
  };

  const handleCloseMenu = () => {
    setMenuRowIndex(null);
    setMenuPosition(null);
  };

  const handleSubmenuOpen = (event, type) => {
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.top;
    let left = rect.right;
    setSubmenuPosition({ top, left });
    setSubmenuOpen(true);
    setMenuType(type === 'report' ? reportSubmenu : roadSubmenu);
  };

  const handleSubmenuClose = () => {
    setSubmenuOpen(false);
  };

  const handleQuickViewRoute = (e, menuItem) => {
    e.stopPropagation();

    if (menuItem.type === 'ROAD') {
      dispatch(
        setTimeSearching({
          id: vehicleSub.device_id,
          license_plate: vehicleSub.license_plate,
          data: menuItem
        })
      );
    }

    navigate(`${menuItem.url}`);
    setMenuPosition(null);
  };

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const vehicle = allVehicles[rowIndex];
    if (!vehicle) return null;

    let content;
    if (columnIndex === 0) {
      content = <VehicleTablecell row={vehicle} index={rowIndex} />;
    } else if (columnIndex === 1) {
      if (vehicle.debt) {
        content = (
          <span align="center" style={{ color: '#D9042F' }}>
            Hết hạn gói dịch vụ
          </span>
        );
      } else {
        content = (
          <span align="center">{Math.floor(vehicle.speed_gps) || 0}</span>
        );
      }
    } else if (columnIndex === 2) {
      if (vehicle.debt) {
        content = null;
      } else {
        content = (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <span
              align="center"
              style={{
                display: 'inline-block'
              }}
            >
              {vehicle
                ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
                : '--'}
            </span>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                height: '20px',
                width: '20px',
                transition: 'transform 0.3s ease',
                transform:
                  menuRowIndex === rowIndex ? 'rotate(90deg)' : 'rotate(0deg)'
              }}
              onClick={e => handleClickMenu(e, rowIndex, vehicle)}
            >
              <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
            </div>
          </div>
        );
      }
    }

    const isActive = vehicle.device_id === rowActive;

    return (
      <Box
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #ddd',
          fontSize: '12px',
          cursor: 'pointer',
          backgroundColor: isActive ? '#FFE4E1' : '#F5F5F5'
        }}
        onClick={() => handleRowClick(vehicle)}
      >
        {content}
      </Box>
    );
  };


  return (
    <TableContainer
      component={Paper}
      className="vehicle_table"
      style={{
        maxHeight: '100%',
        width: '100%',
        overflowY: allVehicles.length * 38 > 500 ? 'auto' : 'hidden',
        overflowX: 'hidden',
        border:'1px solid rgba(60, 64, 67, 0.15)'
      }}
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        style={{
          tableLayout: 'fixed'
        }}
      >
        <TableHead
          style={{
            background: '#D9042F !important',
            color: 'white !important'
          }}
        >
          <TableRow>
            <TableCell align="center">Tên/Biển số</TableCell>
            <TableCell align="center">Vận tốc (Km/h)</TableCell>
            <TableCell align="center">Thời gian</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <FixedSizeGrid
              columnCount={3}
              columnWidth={118}
              height={600}
              rowCount={allVehicles.length}
              rowHeight={38}
              width={358}
            >
              {Cell}
            </FixedSizeGrid>
        </TableBody>
        {menuPosition && (
          <div
            style={{
              position: 'fixed',
              top: menuPosition.top,
              left: menuPosition.left,
              backgroundColor: '#fff',
              boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
              zIndex: 9999,
              minWidth: '140px',
              borderRadius: '4px'
            }}
            onMouseLeave={() => {
              handleCloseMenu();
              handleSubmenuClose();
            }}
          >
            <List style={{ fontSize: '14px' }}>
              <ListItem
                className={classes.menuItem}
                onMouseEnter={e => handleSubmenuOpen(e, 'road')}
                onMouseLeave={handleSubmenuClose}
                style={{ padding: '5px 10px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <span>Xem lộ trình</span>
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      height: '20px',
                      width: '20px'
                    }}
                  >
                    <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                  </span>
                </div>
              </ListItem>

              <Divider />
              <ListItem
                className={classes.menuItem}
                onMouseEnter={e => handleSubmenuOpen(e, 'report')}
                onMouseLeave={handleSubmenuClose}
                style={{ padding: '5px 10px', pointerEvents: !isCar4G ? 'none' : 'auto' }}
                disabled = {!isCar4G}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <span>Báo cáo</span>
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      height: '20px',
                      width: '20px'
                    }}
                  >
                    <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                  </span>
                </div>
              </ListItem>

              <Divider />
              <ListItem
                className={classes.menuItem}
                onClick={() => navigate('/app/image')}
                style={{ padding: '5px 10px' }}
                disabled = {!isCamera4G}
              >
                <span>Xem hình ảnh</span>
              </ListItem>

              <Divider />
              <ListItem
                className={classes.menuItem}
                onClick={() => navigate('/app/camera/streaming?show_menu=true')}
                style={{ padding: '5px 10px' }}
                disabled = {!isCamera4G}
              >
                <span>Xem video live</span>
              </ListItem>
            </List>

            {submenuOpen && submenuPosition && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 141,
                  backgroundColor: '#fff',
                  boxShadow: '0px 1px 10px rgba(36, 36, 36, 0.2)',
                  zIndex: 1000,
                  minWidth: '200px',
                  borderRadius: '4px'
                }}
                onMouseLeave={handleSubmenuClose}
                onMouseEnter={() => setSubmenuOpen(true)}
              >
                <List style={{ fontSize: '14px' }}>
                  {menuType.map((item, index) => (
                    <React.Fragment key={index}>
                      <ListItem
                        className={classes.menuItem}
                        onClick={e => handleQuickViewRoute(e, item)}
                        style={{ padding: '5px 10px' }}
                      >
                        <span>{item.name}</span>
                      </ListItem>
                      {index !== menuType.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}
          </div>
        )}
      </Table>
    </TableContainer>
  );
};

const useStyles = makeStyles(theme => ({
  menuItem: {
    padding: '8px 12px',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  }
}));

export default React.memo(VehicleTable);
